import { ChangeDetectionStrategy, Component, ElementRef, HostListener, Input, OnInit } from '@angular/core'
import { ITrack } from '../../../../Interface/track'

@Component({
  selector: 'bmcore-track-mob-controls',
  templateUrl: './bmcore-track-mob-controls.component.html',
  styleUrls: ['./bmcore-track-mob-controls.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreTrackMobControlsComponent implements OnInit {
  @Input() track: ITrack
  @Input() isShowFavBtn: boolean
  @Input() showDownloadBtn = false
  @Input() showShareBtn = false

  isDropdownOpen = false

  constructor(private eRef: ElementRef) {}

  ngOnInit(): void {}

  // close search dropdown when click outside
  // https://stackoverflow.com/a/40107009
  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (!this.eRef.nativeElement.contains(event.target)) {
      this.isDropdownOpen = false
    }
  }

  toggleDropdown(event: MouseEvent) {
    event.stopPropagation()
    this.isDropdownOpen = !this.isDropdownOpen
  }
}
